'use client';

import { RefObject, useRef } from 'react';

import { clsx } from 'clsx';

import { PageWithMenu } from '@app/layouts/PageWithMenu';
import { ROUTES } from '@shared/constants/routes';
import { useAppSelector } from '@shared/hooks/redux';
import { PageHead } from '@shared/ui/PageHead';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { VStack } from '@shared/ui/Stack';

import cls from './Split.module.scss';

const TITLE = 'Что такое Сплит?';

const crumbs = [
  { label: 'Главная', url: ROUTES.MAIN },
  { label: TITLE, url: '' }
];

const MENU_ITEMS = [
  { key: '1', title: 'Простое использование' },
  { key: '2', title: 'Оформление заказа' }
];

export const Split = () => {
  const sectionRef1 = useRef<HTMLDivElement>(null);
  const sectionRef2 = useRef<HTMLDivElement>(null);

  const viewPort = useAppSelector(getViewPort);

  const refs = [sectionRef1, sectionRef2];

  const scrollToSection = (ref: RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const top = ref.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: top - (viewPort === 'mobile' ? 50 : 120), behavior: 'smooth' });
    }
  };

  return (
    <div className={cls.wrap}>
      <PageHead breadcrumbs={crumbs} />
      <PageWithMenu
        menu={
          <>
            <p className={cls.menuTitle}>Содержание</p>
            <VStack className={cls.menuContent}>
              {MENU_ITEMS.map(({ key, title }, i) => (
                <div
                  key={key}
                  className={cls.menuItem}
                  onClick={() => scrollToSection(refs[i])}
                >
                  {title}
                </div>
              ))}
            </VStack>
          </>
        }
      >
        <VStack className={cls.content}>
          <section>
            <h2 className={clsx(cls.title, cls.sectionTitle)}>Что такое Сплит?</h2>
            <div>
              <p>
                Это сервис для оплаты покупок частями. Делите оплату на 2, 4 или 6 месяцев. Получайте заказы сразу, а
                платите за них постепенно
              </p>
            </div>
          </section>

          <section ref={sectionRef1}>
            <h2 className={clsx(cls.title, cls.sectionTitle)}>Простое использование</h2>
            <div>
              <ul>
                <li>
                  Покупка уже ваша <br /> Выбирайте любые понравившиеся товары, сборка заказа начнётся сразу после
                  оформления и оплаты первой части от стоимости.
                </li>
                <li>
                  Небольшие платежи <br /> При оплате заказа со Сплитом сумма делится на части. Вы можете разделить
                  оплату на 2, 4 или 6 месяцев. Первый платеж спишется сразу, остальные — по графику, который вы увидите
                  при оформлении.
                </li>
                <li>
                  Без анкет и ожидания <br /> При оплате Сплитом достаточно перейти в Яндекс Пэй и выбрать привязанную
                  карту. При отмене заказа деньги вернутся вам на карту.
                </li>
              </ul>
            </div>
          </section>

          <section ref={sectionRef2}>
            <h2 className={clsx(cls.title, cls.sectionTitle)}>Оформление заказа</h2>
            <div>
              <ul>
                <li> Выберите товар, на который доступен Сплит, и добавьте его в корзину</li>
                <li> Откройте корзину и нажмите Перейти к оформлению.</li>
                <li>
                  {' '}
                  Выберите{' '}
                  <a
                    target={'_blank'}
                    href="https://yandex.ru/support/split/ru/conditions#payment-plan"
                  >
                    длительность Сплита
                  </a>
                  .
                </li>
                <li> Выберите способ доставки, укажите адрес и данные пользователя.</li>
                <li>Включите опцию Разбить платёж на части.</li>
                <li>Подтвердите номер телефона кодом из СМС.</li>
                <li>Введите данные банковской карты.</li>
              </ul>
              <p>
                Следить за графиком платежей можно на странице заказа или в{' '}
                <a
                  target={'_blank'}
                  href="https://bank.yandex.ru/my/split/account"
                >
                  личном кабинете
                </a>{' '}
                Сплита.
              </p>
            </div>
          </section>
        </VStack>
      </PageWithMenu>
    </div>
  );
};
